/**
 * Converts a numeric padding value to a Tailwind CSS padding class
 * @param value - The numeric padding value (0, 1, 2, 4, 6, 8, 10, 12, etc.)
 * @param direction - The padding direction ('top' or 'bottom')
 * @returns A Tailwind CSS class string (e.g., 'pt-4', 'pb-8') or empty string for value 0
 */
export const getPaddingClass = (
  value: number,
  direction: 'top' | 'bottom',
): string => {
  if (value === 0) return '';
  const prefix = direction === 'top' ? 'pt-' : 'pb-';
  return `${prefix}${value}`;
};
